import { Button, Modal, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import styles from './styles.css';

interface IRemoveModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
}

export const RemoveModal: React.FC<IRemoveModalProps> = ({ isOpen, onClose, onRemove }) => {
  const onDeleteButtonClick = () => {
    onClose();
    onRemove();
  };

  return (
    <Modal
      size="S"
      header={<UIHeading2>Удалить сохранённый поиск?</UIHeading2>}
      open={isOpen}
      onOpenChange={onClose}
      footer={
        <div className={styles['buttons']}>
          <Button size="M" theme="fill_secondary" onClick={onClose}>
            Отмена
          </Button>
          <div className={styles['delete-button']}>
            <Button size="M" theme="fill_primary" onClick={onDeleteButtonClick} data-name="delete-button">
              Удалить
            </Button>
          </div>
        </div>
      }
    />
  );
};
